import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Mail, Phone, Building2, MessageSquare } from "lucide-react";
import { api, apiError } from "../../lib/api";
import { Button } from "../ui/button";

export const EnquiriesManager = () => {
  const [enquiries, setEnquiries] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/enquiries");
      setEnquiries(data);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    }
  };
  useEffect(() => { load(); }, []);

  const remove = async (e) => {
    if (!window.confirm("Delete this enquiry?")) return;
    await api.delete(`/admin/enquiries/${e.id}`);
    toast.success("Enquiry deleted");
    load();
  };

  const fmt = (iso) => {
    const d = new Date(iso);
    return isNaN(d) ? iso : d.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
  };

  return (
    <div data-testid="admin-enquiries-manager">
      <h2 className="font-serif text-2xl text-cream">
        Customer Enquiries <span className="text-sm text-muted-foreground">({enquiries.length})</span>
      </h2>

      {enquiries.length === 0 && (
        <p className="mt-6 text-sm text-muted-foreground" data-testid="admin-enquiries-empty">
          No enquiries yet.
        </p>
      )}

      <div className="mt-6 space-y-3">
        {enquiries.map((e) => (
          <div key={e.id} data-testid={`admin-enquiry-row-${e.id}`}
            className="rounded-xl border border-border bg-card p-4">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="text-sm font-semibold text-cream" data-testid={`admin-enquiry-name-${e.id}`}>
                  {e.name || "Anonymous"}
                  {e.enquiry_type ? (
                    <span className="ml-2 rounded-full border border-border px-2 py-0.5 text-[11px] uppercase tracking-[0.12em] text-caramel">
                      {e.enquiry_type}
                    </span>
                  ) : null}
                </p>
                <p className="mt-1 text-xs text-muted-foreground" data-testid={`admin-enquiry-date-${e.id}`}>
                  {fmt(e.created_at)}
                </p>
              </div>
              <Button size="icon" variant="ghost" onClick={() => remove(e)}
                data-testid={`admin-delete-enquiry-${e.id}`}>
                <Trash2 className="h-4 w-4 text-red-400" />
              </Button>
            </div>

            <div className="mt-3 flex flex-wrap gap-x-6 gap-y-1.5 text-xs text-cream/70">
              {e.company && (
                <span className="flex items-center gap-1.5"><Building2 className="h-3.5 w-3.5 text-copper" /> {e.company}</span>
              )}
              {e.phone && (
                <span className="flex items-center gap-1.5"><Phone className="h-3.5 w-3.5 text-copper" /> {e.phone}</span>
              )}
              {e.email && (
                <span className="flex items-center gap-1.5"><Mail className="h-3.5 w-3.5 text-copper" /> {e.email}</span>
              )}
            </div>

            {e.message && (
              <p className="mt-3 flex gap-2 text-sm text-cream/80">
                <MessageSquare className="mt-0.5 h-4 w-4 shrink-0 text-copper" /> {e.message}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
